import { render } from "./PointHistories.vue?vue&type=template&id=79f52feb&scoped=true"
import script from "./PointHistories.vue?vue&type=script&lang=js"
export * from "./PointHistories.vue?vue&type=script&lang=js"

import "./PointHistories.vue?vue&type=style&index=0&id=79f52feb&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-79f52feb"

export default script